import { createLayoutResizeApi_structure } from './createLayoutResizeApi_structure';

import type { CompRef } from 'types/documentServices';
import type { EditorAPI } from '#packages/editorAPI';
import type { HistoryApi } from '../createHistoryApi';
import type { LayoutGetApi } from '../layoutGetApi';
import type { LayoutApiByStructure } from '../createLayoutApi_structure';
import { updateLayoutUtil } from '#packages/layoutUtils';
import type { CompPointersApi } from '#packages/compPointers';
import type {
  LayoutResizeToOptions,
  LayoutResizeToAndPushOptions,
} from './types';

export function createLayoutResizeApi({
  editorAPI,
  historyApi,
  layoutGetApi,
  layoutApi_structure,
}: {
  editorAPI: EditorAPI;
  historyApi: HistoryApi;
  layoutGetApi: LayoutGetApi;
  compPointersApi: CompPointersApi;
  layoutApi_structure: LayoutApiByStructure;
}) {
  const layoutResizeApi_structure = createLayoutResizeApi_structure({
    editorAPI,
    historyApi,
  });

  const historyAdd = (
    label: string,
    { dontAddToUndoRedoStack }: { dontAddToUndoRedoStack?: boolean },
  ) => {
    if (!dontAddToUndoRedoStack) {
      editorAPI.history.debouncedAdd(label);
    }
  };

  function resizeTo(
    compRef: CompRef,
    size: { width?: number; height?: number },
    options: LayoutResizeToOptions = {},
  ) {
    const sizeAfterConstrains = updateLayoutUtil.getLayoutAfterConstraints(
      editorAPI,
      compRef,
      size,
      layoutGetApi.get(compRef),
    );

    // eslint-disable-next-line @wix/santa-editor/deprecatedDSApi
    editorAPI.dsActions.components.layout.update(compRef, sizeAfterConstrains);

    historyAdd('component - update layout size', options);
  }

  function resizeToAndPush(
    compRef: CompRef,
    size: { width?: number; height?: number },
    options: LayoutResizeToAndPushOptions = {},
  ) {
    layoutApi_structure.updateAndAdjustLayout(
      compRef,
      size,
      options.dontAddToUndoRedoStack,
    );
  }

  return {
    resizeTo,
    resizeToAndPush,
    resizeToAndPushTransition:
      layoutResizeApi_structure.resizeToAndPushTransition,
  };
}

export type LayoutResizeApi = ReturnType<typeof createLayoutResizeApi>;
